import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Grid } from '@bingads-webui-campaign-react/ads-studio-shared-components';
import { withAdsStudioStyles } from '../../theme/with-ads-studio-styles';

import { getTilesGridStyle } from './styles/tiles-grid-style';
import { DEFAULT_CONFIG } from './default-grid-config';


const TilesGridInternal = ({
  items,
  onRenderCell,
  config,
  classes,
}) => {
  const onRenderCellImpl = useCallback((gridItem) => {
    const { item } = gridItem;
    const { _index } = item;
    return (
      <div className="tiles-grid-cell">
        {onRenderCell({ item, index: _index })}
      </div>
    );
  }, [onRenderCell]);

  return (
    <div className={classNames('tiles-grid-container', classes.tilesGridContainer)}>
      <Grid
        items={items}
        renderItem={onRenderCellImpl}
        columnWidth={config.width || undefined}
        rowHeight={config.height || undefined}
        gridMode={config.gridMode || undefined}
        columnPadding={config.columnPadding || undefined}
        rowPadding={config.rowPadding || undefined}
        scrollContainer={config.scrollContainer}
        maxColumns={config.maxColumns}
        minItemHeight={config.minItemHeight}
      />
    </div>
  );
};

TilesGridInternal.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onRenderCell: PropTypes.func.isRequired,
  config: PropTypes.shape({
    aspectRatio: PropTypes.number,
    maxColumnWidth: PropTypes.number,
    minColumnWidth: PropTypes.number,
    rowHeight: PropTypes.number,
    preferredCellsPerPage: PropTypes.number,
    columnPadding: PropTypes.number,
  }),
  // injected styles
  classes: PropTypes.shape({
    tilesGridContainer: PropTypes.string,
  }).isRequired,
};

TilesGridInternal.defaultProps = {
  items: [],
  config: DEFAULT_CONFIG,
};

export const TilesGrid = withAdsStudioStyles(TilesGridInternal, getTilesGridStyle);
